import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import SiteFooter from "@/components/SiteFooter";
import { api } from "@/lib/api";
import { CalendarDays, Tag, ArrowLeft } from "lucide-react";

export default function BlogArticle() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api
      .get(`/blog/${slug}`)
      .then((r) => setArticle(r.data))
      .catch((e) => {
        if (e.response?.status === 404) setNotFound(true);
      });
  }, [slug]);

  return (
    <div className="min-h-screen navy-glow flex flex-col" data-testid="blog-article-page">
      <Navbar variant="public" />
      <main className="flex-1">
        <section className="max-w-3xl mx-auto px-6 py-16 w-full">
          <Link to="/blog" data-testid="blog-back-link" className="chip mb-6 inline-flex">
            <ArrowLeft className="w-3.5 h-3.5" /> All articles
          </Link>
          {notFound && (
            <div className="soft-card p-10 text-center">
              <div className="font-display text-xl font-bold text-slate-900">
                We couldn't find this article.
              </div>
              <div className="text-slate-500 mt-2">
                It may have been unpublished. Head back to the{" "}
                <Link to="/blog" className="text-brand underline font-semibold">
                  blog index
                </Link>
                .
              </div>
            </div>
          )}
          {article && (
            <article className="soft-card p-8 md:p-10" data-testid="blog-article">
              <div className="chip-light mb-4">
                <Tag className="w-3.5 h-3.5" /> {article.category}
              </div>
              <h1 data-testid="blog-article-title" className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
                {article.title}
              </h1>
              <div className="flex flex-wrap items-center gap-3 mt-3 text-sm text-slate-500">
                <span className="flex items-center gap-1">
                  <CalendarDays className="w-4 h-4" />{" "}
                  {article.published_at ? new Date(article.published_at).toLocaleDateString() : ""}
                </span>
                <span>·</span>
                <span>{article.author}</span>
              </div>
              <div
                data-testid="blog-article-content"
                className="prose prose-slate max-w-none mt-8 text-slate-700 leading-relaxed whitespace-pre-line text-[16px]"
              >
                {article.content}
              </div>
            </article>
          )}
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
